import type { OrganizationRoles } from '../constants/organizations'
import type { WorkspaceRoles } from '../constants/workspaces'

const CLAIMS_ROLE_SEPARATOR = '-'

export const encodeAccessClaims = (
  id: string,
  role: OrganizationRoles | WorkspaceRoles,
) => {
  return `${id}${CLAIMS_ROLE_SEPARATOR}${role}`
}

export const decodeAccessClaims = (claimsId: string) => {
  const [id, role] = claimsId.split(CLAIMS_ROLE_SEPARATOR)
  return { id, role }
}
